import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import SimulationChat from "@/pages/SimulationChat";
import ProgressPage from "@/pages/ProgressPage";
import AdminPanel from "@/pages/AdminPanel";
import LeaderboardPage from "@/pages/LeaderboardPage";
import ScenarioBuilder from "@/pages/ScenarioBuilder";
import ApiIntegration from "@/pages/ApiIntegration";
import OrgManagement from "@/pages/OrgManagement";
import ReportsDashboard from "@/pages/ReportsDashboard";
import AssignmentsPage from "@/pages/AssignmentsPage";
import SimulationReport from "@/pages/SimulationReport";
import ReportBuilder from "@/pages/ReportBuilder";
import ManagerDashboard from "@/pages/ManagerDashboard";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="heritage-card p-8 text-center">
        <div className="w-8 h-8 border-2 border-brand border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-body text-foreground">Loading...</p>
      </div>
    </div>
  );
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/simulation/:simId" element={<ProtectedRoute><SimulationChat /></ProtectedRoute>} />
            <Route path="/report/:simId" element={<ProtectedRoute><SimulationReport /></ProtectedRoute>} />
            <Route path="/progress" element={<ProtectedRoute><ProgressPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
            <Route path="/admin/scenarios" element={<ProtectedRoute><ScenarioBuilder /></ProtectedRoute>} />
          <Route path="/admin/api" element={<ProtectedRoute><ApiIntegration /></ProtectedRoute>} />
            <Route path="/admin/org" element={<ProtectedRoute><OrgManagement /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute><ReportsDashboard /></ProtectedRoute>} />
            <Route path="/admin/assignments" element={<ProtectedRoute><AssignmentsPage /></ProtectedRoute>} />
            <Route path="/admin/report-builder" element={<ProtectedRoute><ReportBuilder /></ProtectedRoute>} />
            <Route path="/manager" element={<ProtectedRoute><ManagerDashboard /></ProtectedRoute>} />
            <Route path="/leaderboard" element={<ProtectedRoute><LeaderboardPage /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
